/**
 * `#<order> <sku>` label for a per-film warning/summary line at the
 * Film-Print station (BLU-233 quick task 260818-7oj). Was built inline in
 * two places (`prepareAndDropUnitCore`, `formatPrepareFailureLine`) — one
 * shared helper now. shopifySku (design-bearing) is preferred over base sku
 * so two customs sharing a blank produce distinct labels. order_name usually
 * already starts with '#' — stripOrderNamePrefix normalises before the
 * single '#' prefix here (the compositor learned the same lesson; "##161675"
 * shipped in a real dialog before this normalise).
 */
import { stripOrderNamePrefix } from '@threadheads/shared';

export interface UnitLabelGarment {
  orderNumber?: string | null;
  shopifySku?: string | null;
  sku?: string | null;
}

export function formatUnitLabel(garment: UnitLabelGarment | undefined): string {
  return `#${stripOrderNamePrefix(garment?.orderNumber ?? '')} ${garment?.shopifySku ?? garment?.sku ?? ''}`.trim();
}
